/**
 * Logger — 統一日誌工具
 *
 * 開發模式下輸出，生產模式下靜默。
 * 未來可接入遠端日誌收集。
 */

const envDev: boolean | undefined = import.meta.env.DEV as boolean | undefined;
const isDev = envDev ?? true;

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

function createLogger(prefix: string) {
  const log = (level: LogLevel, ...args: unknown[]) => {
    if (!isDev && level !== 'error') return;
    const fn = level === 'debug' ? console.log : console[level];
    fn(`[${prefix}]`, ...args);
  };

  return {
    debug: (...args: unknown[]) => { log('debug', ...args); },
    info: (...args: unknown[]) => { log('info', ...args); },
    warn: (...args: unknown[]) => { log('warn', ...args); },
    error: (...args: unknown[]) => { log('error', ...args); },
  };
}

export const logger = createLogger('XLW');

export function getLogger(prefix: string) {
  return createLogger(prefix);
}
